module.exports = __webpack_public_path__ + "img/icon.b2e81a9f.png";